import { render, staticRenderFns } from "./AttVerifiedBy.vue?vue&type=template&id=89174818&scoped=true"
import script from "./AttVerifiedBy.vue?vue&type=script&lang=js"
export * from "./AttVerifiedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89174818",
  null
  
)

export default component.exports